import { Alert, Empty, Typography } from 'antd';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';
import { ITaskNote } from 'client/routes/procedure/single/notes/mapProcedureNotes';
import { ResponsiveCard } from 'client/ui/card/ResponsiveCard';
import * as React from 'react';
import { NoteItem } from '../../../../components/schema/note/NoteItem';

export interface TabNotesProps {
  notes: ITaskNote[];
  error?: any;
}

/**
 * Tab delle note di un procedimento/task
 */
export function TabNotes(props: TabNotesProps) {
  const { notes, error } = props;

  if (error) {
    return (
      <Alert
        showIcon
        type="error"
        message="Impossibile caricare le note"
        description={getNetworkErrorMessage(error, 'Si è verificato un errore')}
      />
    );
  }

  if (notes.length === 0) {
    return (
      <ResponsiveCard bordered={false}>
        <Empty
          description={
            <Typography.Text type="secondary">
              Non ci sono ancora note per questo procedimento
            </Typography.Text>
          }
        />
      </ResponsiveCard>
    );
  }

  return (
    <ResponsiveCard bordered={false}>
      {notes.map((note, i) => (
        <NoteItem key={i} note={note} />
      ))}
    </ResponsiveCard>
  );
}
